/**
 * Admin message API calls.
 */
import api from "@/utils/axios";
import type { AdminUserMessageRequest, UserMessage } from "@/types/message.types";

export const sendAdminMessage = async (
  payload: AdminUserMessageRequest
): Promise<UserMessage> => {
  const response = await api.post<UserMessage>("/admin/messages", payload);
  return response.data;
};
